export const FETCH_SCENARIO_DETAILS = 'FETCH_SCENARIO_DETAILS';

export const CREATE_SCENARIO_DETAIL = 'CREATE_SCENARIO_DETAIL';
export const CREATE_SCENARIO_DETAIL_SUCCESS = 'CREATE_SCENARIO_DETAIL_SUCCESS';
export const CREATE_SCENARIO_DETAIL_FAILURE = 'CREATE_SCENARIO_DETAIL_FAILURE';

export const EDIT_SCENARIO_DETAIL = 'EDIT_SCENARIO_DETAIL';
export const EDIT_SCENARIO_DETAIL_SUCCESS = 'EDIT_SCENARIO_DETAIL_SUCCESS';
export const EDIT_SCENARIO_DETAIL_FAILURE = 'EDIT_SCENARIO_DETAIL_FAILURE';

export const REMOVE_SCENARIO_DETAIL = 'REMOVE_SCENARIO_DETAIL';
export const REMOVE_SCENARIO_DETAIL_SUCCESS = 'REMOVE_SCENARIO_DETAIL_SUCCESS';
export const REMOVE_SCENARIO_DETAIL_FAILURE = 'REMOVE_SCENARIO_DETAIL_FAILURE';
